import React, { useState } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from '@bnvsrnd/brand-assets';
import PolicyAgreement from './PolicyAgreement';

/**
 * 로그인/게스트 입장 요청이 서버로부터 428(CONSENT_REQUIRED)을 받았을 때 띄우는 동의 모달.
 * 이미 자격증명/입장정보는 제출된 뒤라, 여기서는 동의 여부만 받아
 * onAgree()로 "동의 플래그를 포함해 원래 요청을 재시도"하도록 호출자에게 위임한다.
 */
function ConsentModal({ open, group, onAgree, onClose, submitting }) {
    // promotional은 'student' 그룹에서만 쓰이는 선택 항목 — 다른 그룹에서는 그냥 무시된다.
    const [checked, setChecked] = useState({ terms: false, privacy: false, promotional: false });

    const handleChange = (field, value) => {
        setChecked((prev) => ({ ...prev, [field]: value }));
    };

    const canAgree = checked.terms && checked.privacy;

    return (
        <Modal open={open} onClose={onClose}>
            <ModalHeader>이용약관 동의가 필요합니다</ModalHeader>
            <ModalBody>
                <p style={{ marginTop: 0, marginBottom: 'var(--space-3)', fontSize: 14 }}>
                    계속 이용하려면 아래 약관에 동의해주세요.
                </p>
                <PolicyAgreement group={group} checked={checked} onChange={handleChange} />
            </ModalBody>
            <ModalFooter>
                <Button variant="secondary" onClick={onClose} disabled={submitting}>취소</Button>
                <Button
                    variant="primary"
                    onClick={() => onAgree(checked)}
                    disabled={!canAgree}
                    loading={submitting}
                >
                    동의하고 계속하기
                </Button>
            </ModalFooter>
        </Modal>
    );
}

export default ConsentModal;
